import AuthService from "../login/auth.service";
import { dimo, basaSipacoop } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class CuentaExternaService {

  async getCuentasExternas(intermediario) {
    var data = JSON.stringify({
      intermediario: intermediario
    });
    var config = {
      method: "post",
      url: dimo + "cuentasExternasXpress/listar",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async addCuentaExterna(nombreDestino, ctaDestino, tipoDocumento, nroDocDestino, entidad, intermediario, destinatario) {

    var data = {
      cedulaSocio: AuthService.getSocio().numeroCedula,
      nombreDestino: nombreDestino,
      tipoCuenta: intermediario,
      cuentaDestino: destinatario === "1600" ? nroDocDestino : ctaDestino,
      entidad: { "id": entidad },
      tipoDocumento: { "id": tipoDocumento },
      numeroDocumentoDestino: nroDocDestino,
      destinatario: destinatario
    };

    var config = {
      method: "post",
      url: basaSipacoop + "cuentasdestinos",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

}
export default new CuentaExternaService();
